import PropTypes from "prop-types";
import StringCell from "tables/common/StringCell";

export default function CommonStringCell({ getValue }) {
  const value = getValue();

  return <StringCell value={value?.toString()} />;
}

CommonStringCell.propTypes = {
  getValue: PropTypes.func.isRequired,
};
